import type { TCreatePersonResponseBodyDTO } from '@doutorsim/shared/persons'
import type { TFindPersonOfficialDataResponseBodyDTO } from '@doutorsim/shared/exposed/persons'
import { apiClient } from '../api'

class StaffPersonsApi {
  async get(companyId: string, personId: string) {
    return apiClient.get<TCreatePersonResponseBodyDTO>(
      `/api/v1/companies/${companyId}/persons/${personId}`,
    )
  }

  async getOfficialData(
    companyId: string,
    personId: string,
  ): Promise<TFindPersonOfficialDataResponseBodyDTO | null> {
    const { data } = await apiClient.get<TFindPersonOfficialDataResponseBodyDTO>(
      `/api/v1/staff/companies/${companyId}/persons/${personId}/official-data`,
    )
    return data ?? null
  }
}

export const staffPersonsApi = new StaffPersonsApi()
